"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    FilterGroupWrapper: ()=>FilterGroupWrapper
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_Button_index_cjs_namespaceObject = require("../../Button/index.cjs");
const Collapsible_cjs_namespaceObject = require("../../Collapsible/Collapsible.cjs");
const external_Text_index_cjs_namespaceObject = require("../../Text/index.cjs");
function areAllItemsSelected(items) {
    return items.every((item)=>item.checked);
}
function areNoItemsSelected(items) {
    return items.every((item)=>!item.checked);
}
function renderActionButtons({ selectable, resettable, isAllSelected, isNoneSelected, onSelectAll, onSelectNone, onReset }) {
    if (selectable) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
                type: "tertiary",
                size: "sm",
                onClick: (e)=>{
                    e.stopPropagation();
                    onSelectNone?.();
                },
                disabled: isNoneSelected,
                children: "None"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
                type: "tertiary",
                size: "sm",
                onClick: (e)=>{
                    e.stopPropagation();
                    onSelectAll?.();
                },
                disabled: isAllSelected,
                children: "All"
            })
        ]
    });
    if (resettable) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
        type: "tertiary",
        size: "sm",
        onClick: (e)=>{
            e.stopPropagation();
            onReset?.();
        },
        children: "Reset"
    });
    return null;
}
function renderHeaderContent({ title, selectable, resettable, isAllSelected, isNoneSelected, onSelectAll, onSelectNone, onReset }) {
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0, index_cjs_namespaceObject.cn)('flex w-full items-center justify-between', selectable || resettable ? 'h-16' : 'h-12'),
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("h5", {
                className: "text-heading5",
                children: title
            }),
            renderActionButtons({
                selectable,
                resettable,
                isAllSelected,
                isNoneSelected,
                onSelectAll,
                onSelectNone,
                onReset
            })
        ]
    });
}
function renderShowMoreContent({ showMoreNeeded, remainingItems, showMoreText, panelId, children }) {
    if (!showMoreNeeded) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Collapsible_cjs_namespaceObject.Collapsible, {
        heading: null,
        defaultOpen: false,
        panelId: panelId,
        collapsedFooter: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            children: showMoreText ?? `Show ${remainingItems.length} more`
        }),
        expandedFooter: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            children: "Show less"
        }),
        children: 'function' == typeof children ? children(remainingItems) : null
    });
}
function FilterGroupWrapper({ children, collapsible = false, defaultCollapsed = false, showMoreLimit, resettable = false, onReset, className = '', selectable = false, onSelectAll, onSelectNone, isAllSelected = false, isNoneSelected = false, items = [], groups, panelId = '', title, showMoreText }) {
    if (groups && groups.length > 0) {
        const allItems = groups.flatMap((group)=>group.items);
        const allItemsIsAllSelected = areAllItemsSelected(allItems);
        const allItemsIsNoneSelected = areNoItemsSelected(allItems);
        const renderGroup = (group, index)=>{
            const showMoreNeeded = group.showMoreLimit && group.items.length > group.showMoreLimit;
            const visibleItems = showMoreNeeded ? group.items.slice(0, group.showMoreLimit) : group.items;
            const remainingItems = showMoreNeeded ? group.items.slice(group.showMoreLimit) : [];
            const groupIsAllSelected = areAllItemsSelected(group.items);
            const groupIsNoneSelected = areNoItemsSelected(group.items);
            const groupContent = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "flex flex-col gap-2",
                children: 'function' == typeof children ? children(visibleItems) : children
            });
            const groupHeaderContent = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: (0, index_cjs_namespaceObject.cn)('flex w-full items-center justify-between'),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                        textStyle: "body3",
                        palette: "primary",
                        shade: "13",
                        bold: true,
                        className: "mb-3",
                        children: group.subtitle
                    }),
                    renderActionButtons({
                        selectable: !!group.selectable,
                        resettable: !!group.resettable,
                        isAllSelected: groupIsAllSelected,
                        isNoneSelected: groupIsNoneSelected,
                        onSelectAll: group.onSelectAll,
                        onSelectNone: group.onSelectNone,
                        onReset: group.onReset
                    })
                ]
            });
            const showMoreContent = renderShowMoreContent({
                showMoreNeeded: !!showMoreNeeded,
                remainingItems,
                showMoreText: group.showMoreText,
                panelId: `${panelId}-${index}-more`,
                children
            });
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: (0, index_cjs_namespaceObject.cn)(index < groups.length - 1 && 'mb-4'),
                children: [
                    groupHeaderContent,
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: "flex flex-col gap-2 pt-1",
                        children: [
                            groupContent,
                            showMoreContent
                        ]
                    })
                ]
            }, `${group.subtitle}-${index}`);
        };
        const content = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: "flex flex-col",
            children: groups.map(renderGroup)
        });
        const headerContent = renderHeaderContent({
            title,
            selectable,
            resettable,
            isAllSelected: allItemsIsAllSelected,
            isNoneSelected: allItemsIsNoneSelected,
            onSelectAll,
            onSelectNone,
            onReset
        });
        if (collapsible) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Collapsible_cjs_namespaceObject.Collapsible, {
            heading: headerContent,
            defaultOpen: !defaultCollapsed,
            panelId: panelId,
            flushAligned: true,
            triggerPadding: "py-0",
            className: className,
            children: content
        });
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: "flex h-12 w-full items-center justify-between",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("h5", {
                        className: "text-heading5",
                        children: title
                    })
                }),
                content
            ]
        });
    }
    const showMoreNeeded = showMoreLimit && items.length > showMoreLimit;
    const visibleItems = showMoreNeeded ? items.slice(0, showMoreLimit) : items;
    const remainingItems = showMoreNeeded ? items.slice(showMoreLimit) : [];
    const groupContent = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "flex flex-col gap-2",
        children: 'function' == typeof children ? children(visibleItems) : children
    });
    const headerContent = renderHeaderContent({
        title,
        selectable,
        resettable,
        isAllSelected,
        isNoneSelected,
        onSelectAll,
        onSelectNone,
        onReset
    });
    const showMoreContent = renderShowMoreContent({
        showMoreNeeded: !!showMoreNeeded,
        remainingItems,
        showMoreText,
        panelId: `${panelId}-more`,
        children
    });
    const content = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: className,
        children: [
            headerContent,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: "flex flex-col gap-2 pt-1",
                children: [
                    groupContent,
                    showMoreContent
                ]
            })
        ]
    });
    const mainContent = collapsible ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Collapsible_cjs_namespaceObject.Collapsible, {
        heading: headerContent,
        defaultOpen: !defaultCollapsed,
        panelId: panelId,
        flushAligned: true,
        triggerPadding: "py-0",
        className: className,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: "flex flex-col gap-2 pt-1",
            children: [
                groupContent,
                showMoreContent
            ]
        })
    }) : content;
    return mainContent;
}
exports.FilterGroupWrapper = __webpack_exports__.FilterGroupWrapper;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "FilterGroupWrapper"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
